import {Component, Input, OnInit} from "@angular/core";
import {AppSearchResult} from "../../../models/appSearch.model";
import {slugify} from "../../../../shared/util/slugify";
import {AuthService} from "../../../../shared/services/auth.service";
import {Article} from "../../../models/article.model";
import {SharedApiService} from "../../../../shared/services/api.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {LoginModalComponent} from "../../login-modal/login-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {AddToShoppingCart} from "../../../../shared/models/add-to-shopping-cart.model";
import {AlertService} from "../../../../shared/services/alert.service";
import {ShoppingCartCountService} from "../../../../shared/services/shopping_cart_count";
import {HttpParams} from "@angular/common/http";

@Component(
        {
            selector: 'catalogue-app-search-results',
            templateUrl: './app-search-results.component.html'
        }
)
export class AppSearchResultsComponent implements OnInit {
    @Input() public results: AppSearchResult[];
    @Input() public totalResults: number;
    @Input() private urlSearchParams: URLSearchParams;

    public canOrder: boolean;

    constructor(
            private authService: AuthService,
            private apiService: SharedApiService,
            private toastrService: ToastrService,
            private translateService: TranslateService,
            private modalService: NgbModal,
            private router: Router,
            private alertService: AlertService,
            private shoppingCartCountService: ShoppingCartCountService,
    ) {

    }

    public ngOnInit() {
        this.canOrder = this.authService.hasRoleOrderer();

        if (this.canOrder) {
            this.apiService.getAssortmentArticles().subscribe(articles => {
                articles.forEach(article => {
                    let result = this.results.find(result => result.guid === article.guid);

                    if (result) {
                        result.inAssortment = true;
                    }
                });
            });
        }
    }

    public getArticle(result: AppSearchResult): Article {
        return {
            slug: this.slug(result.name),
            guid: result.guid,
            cid: result.code,
            name: result.name,
            isCommission: result.isCommission,
            description: result.description,
            minimumOrderQuantity: result.minimumOrderQuantity,
            quantityMultiplier: result.quantityMultiplier,
            quantity: result.quantity,
            articleAttributes: [],
            images: [],
            videos: [],
            mainImage: result.mainImage,
            files: [],
            stock: null,
            inAssortment: result.inAssortment,
            product: null,
            hasVolumePrices: false,
            stockLocations: [],
        } as Article;
    }

    public openLoginModal() {
        const modalRef = this.modalService.open(LoginModalComponent);

        modalRef.componentInstance.currentRoute = this.router.url;
    }

    public addToFavorites(result: AppSearchResult) {
        result.inAssortment = true;

        this.apiService.addToAssortment([result.guid]).subscribe(() => {
            this.toastrService.success(this.translateService.instant('page.assortment.added_to_assortment'));
        });
    }

    public removeFromFavorites(result: AppSearchResult) {
        result.inAssortment = false;

        this.apiService.removeFromAssortment(result.guid).subscribe(() => {
            this.toastrService.success(this.translateService.instant('page.assortment.removed'));
        });
    }

    public changeQuantity(result: AppSearchResult, quantity) {
        quantity = parseInt(quantity);

        if (isNaN(quantity) || quantity === 0) {
            result.quantity = null;

            return;
        }

        result.quantity = quantity;
    }

    public addToShoppingCart() {
        const articles = this.results
                .filter(result => result.quantity > 0)
                .map(result => ({
                    guid: result.guid,
                    quantity: result.quantity,
                } as AddToShoppingCart));

        if (articles.length === 0) {
            this.alertService.alert(this.translateService.instant('global.notification.set_quantity'));
        } else {
            this.apiService.addToShoppingCart(articles).subscribe(result => {
                if ((result.length || 0) > 0) {
                    for (let result of this.results) {
                        result.quantity = null;
                    }

                    this.shoppingCartCountService.updateCount();
                    this.toastrService.success(this.translateService.instant('page.assortment.added_to_shopping_cart'));
                }
            });
        }
    }

    public slug(name: string) {
        return slugify(name);
    }

    public logClickThrough(documentId: string): void {
        this.urlSearchParams.append('documentId', documentId);

        this.apiService.logClickThrough(new HttpParams({fromString: this.urlSearchParams.toString()}))
                .subscribe();
    }
}